<template>
  <div>
    <div class="tech_list_box">
    <div class="storeList flex_center" v-for="(techItem,techIndex) in techList" :key="techIndex" @click="techClick(techItem,techIndex)">
      <!--技师头像-->
      <div class="tech__headBox" v-if="techItem.type=='2'">
        <img class="tech__headImg seniorTech" :src="techItem.thumb?techItem.thumb:techItem.avatar" alt />
        <img class="tech__head_crown" src="/static/img/crown_icon.png" alt />
      </div>
      <div class="tech__headBox" v-if="techItem.type=='1'">
        <img class="tech__headImg seniorTech seniorTech2" :src="techItem.thumb?techItem.thumb:techItem.avatar" alt />
        <img class="tech__head_crown" src="/static/img/crown_icon2.png" alt />
      </div>
      <div class="tech__headBox" v-if="techItem.type=='0'">
        <img class="tech__headImg" :src="techItem.thumb?techItem.thumb:techItem.avatar" alt />
      </div>
      <!--技师内容-->
      <div class="storeList__content flex">
        <div>
          <div class="flex_center techList__title">
            <span>{{techItem.name}}</span>
            <div class="detail_star">
              <span v-for="(item,index) in 5" :key="index">
                <van-icon class="star" size="15px" name="star" v-if="techItem.score > index" :color="star_active" />
                <van-icon class="star" size="15px" name="star" v-else/>
              </span>
            </div>
           
          </div>
          <div class="col_999 fs_12">
            <p>{{techItem.levelname}}</p>
            <div class="flex techList__line">
              <div>个人编号：{{techItem.num_id}}</div>
            </div>
          </div>
        </div>
         <div class="tech_price">￥{{techItem.price}}</div>
        <div class="selectTech__choose">
          <span v-show="techItem.checked==0" class="iconfont icon-danxuanxuanzhong col_ccc"></span><!--未选-->
          <span v-show="techItem.checked==1" class="iconfont icon-radio-checked1 col_45B9BC"></span><!--已选-->
          <span v-show="techItem.checked==2" class="iconfont icon-bukexuan col_e9e9e9"></span><!--不可选-->
        </div>
      </div>
    </div>
    </div>
    <div class="sureBtn__box"><a :class="[used==0?'use_none':'']" @click="select_tech()">确认选择</a></div>
  </div>
</template>

<script>
  export default {
    name: "selectTech",

    data(){
      return{
        service_id:0,
        store_id:0,
        tech_id:0,
        member_total:0,
        service_time:0,
        start_time:0,
        star_active: "#F9CE06",   //星星
        max_num:0,
        //技师列表
        techList: [],
        used:0,//按钮是否可选
      }
    },
     created(){
       this.service_id = this.$route.query.service_id;
       this.tech_id  =this.$route.query.tech_id;
       this.store_id = this.$route.query.store_id;
       this.member_total = this.$route.query.member_total;
       this.service_time = this.$route.query.service_time;
       this.start_time = this.$route.query.start_time;
       this.max_num = this.member_total;
       this.get_tech();
       console.log(this.max_num);
    },
    methods:{
      get_tech(){
         this.axios({
            url: this.api.order.select_tech_list,
            data:{
              'service_id':this.service_id,
              'store_id':this.store_id,
              'service_time':this.service_time, 
              'start_time':this.start_time,
              'tech_id':this.tech_id,
              'member_total':this.member_total
            }
        }).then((res) => {
            if (res.error === 0) {
              this.techList  = res.tech 
              this.$options.methods.update_checked(this); 
            }

        })
      },
      select_tech(){
        if(this.used==0){
            return;
        }
        var tech_ids_arr = [];
        for(let i= 0;i<this.techList.length;i++){
            if(this.techList[i]['checked']==1){
               tech_ids_arr.push(this.techList[i]['id']);
            }
        }
        var tech_ids  = tech_ids_arr.join(",");
        this.axios({
            url: this.api.order.select_tech,
            data:{
              'service_id':this.service_id,
              'service_time':this.service_time,
              'member_total':this.member_total,
              'tech_ids': tech_ids
            }
        }).then((res) => {
            if (res.error === 0) {
               //修改缓存
              var order  = JSON.parse(sessionStorage.getItem("order"));
              order['select_tech'] = res.tech;
              sessionStorage.setItem('order',JSON.stringify(order));
              var jump_data = {
                'service_id':this.service_id,
                'store_id':this.store_id,  
                'member_total':this.member_total,
                'tech_id':tech_ids              
              }
              this.$router.push({path:'bookOrder',query:jump_data});      
            }

        })
      },
      //选择技师
      techClick(techItem,techIndex){
       
        var checked_num = this.$options.methods.checkedNum(this);   //获取当前选择数量
        if(techItem.checked == 0 && checked_num<this.max_num){   //如果未选中并且小于最大可选数量  状态改为选中
          techItem.checked = 1;
        }else if(techItem.checked == 1){       //否则改为不选中
          techItem.checked = 0;
        }

        this.$options.methods.update_checked(this);   //调用
      },
      //计算当前选中的数量
      checkedNum (e) {
        var checked_num = 0;   //定义选中数量的变量
        var that  =this;
        console.log(e.techList.length);
        for (var i = 0; i < e.techList.length; i++) {    //循环数组
          if (e.techList[i].checked == 1) {     //获取被选中的数量
            checked_num++          //累加被选中的数量
          }
        }
        
        return checked_num;
      },
      //更新状态是否可选
      update_checked(e){
       
        var checked_num = e.$options.methods.checkedNum(e);   //调用当前选中的数量
       if(checked_num >= e.max_num){    //如果当前选中数量大于等于最大可选数时
         e.used  = 1; 
          for (var i = 0; i < e.techList.length; i++) {    //把数组里所有可选（为0）的状态全部改为不可选
            if(e.techList[i].checked == 0){
              e.techList[i].checked = 2;
            }
          }
          
        }else{
          e.used = 0 ; 
          for (var i = 0; i < e.techList.length; i++) {    //否则把不可选状态恢复到可选状态
            if(e.techList[i].checked == 2){
              e.techList[i].checked = 0;
            }
          }
        }
      }
    },
  }
</script>

<style scoped>
  @import '../../assets/css/store.css';
  @import '../../assets/css/technician.css';
  .selectTech__choose span{
    font-size: .9rem;
  }
  .use_none{
    background: #ccc;
  }
  .tech_price{
      font-size: 0.8rem;
      font-weight: bold;
      color: #FFA500;
  }
  .tech_list_box{
      margin-bottom: 6rem;
  }
  .sureBtn__box{
      padding: 1rem 2.5rem;
      position: fixed;
      bottom: 0;
      width: 100%;
  }
  
</style>



// WEBPACK FOOTER //
// src/views/book/selectTech.vue